import { memo, useMemo } from 'react';
import CampaignSection from 'components/campaign/campaignSection/CampaignSection';
import { showActionsCreative } from 'utils';
import { useSelector } from 'react-redux';
import DeteilsComponet from './DeteilsComponet';
import { getActiveCreativesList } from 'store/selectors';

const GeneralTrackingSection = ({ environment, expanded, handleChange, error }) => {
  const creativesTracking = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.creativesTracking,
  );

  const activeCreativesList = useSelector(getActiveCreativesList);

  const isCustomTracking = useSelector((state) => state?.tracking?.isCustomTracking);

  const isHiddenFlag = useMemo(() => {
    return showActionsCreative(environment, isCustomTracking, activeCreativesList);
  }, [isCustomTracking, environment, activeCreativesList]);

  return (
    <CampaignSection
      error={error}
      isHidden={isHiddenFlag}
      expanded={expanded === 'conversionTracking'}
      isExpandable={true}
      handleChange={handleChange('conversionTracking')}
      title='Conversion Tracking'
      discription="Once the campaign have more than one tracking link, we can't save the Global tracking
      link."
      details={
        <DeteilsComponet environment={environment} data={creativesTracking} expanded={expanded} />
      }
      showActions={false}
    />
  );
};

export default memo(GeneralTrackingSection);
